module.exports = __webpack_public_path__ + "img/jp.8608025c.svg";